import React from "react";
import { Box, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from "@icons/myicons/plus-circled.svg?react";

interface Props {
  onAddToDepot: () => void;
  handleCloseMenu?: () => void;
}

export const SecurityActionMenuItems = ({
  onAddToDepot,
  handleCloseMenu,
}: Props) => {
  const { t } = useTranslation();

  const handleAddToDepotClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onAddToDepot();
    handleCloseMenu?.();
  };

  return (
    <MenuItem
      onClick={handleAddToDepotClick}
      data-testid="add-to-depot-menu-item"
    >
      <Box display="flex" alignItems="center" gap={3}>
        <AddIcon width={20} height={20} />
        <Typography variant="body3">
          {t("singleSecurityPage.actions.addToDepot")}
        </Typography>
      </Box>
    </MenuItem>
  );
};
